import { createSelector } from "reselect";

const offers = (state) => state.selectGoalActions.offers;
const goals = (state) => state.selectGoalActions.goals;
const goalActions = (state) => state.selectGoalActions.goalActions;

export const getOffers = createSelector(
    offers,
    (offers = []) => {
        return offers.map(item => {
            return {
                title: `(${item.id}) ${item.title}`,
                value: item.id
            };
        });
    }
);

export const getGoals = createSelector(
    goals,
    (goals = []) => {
        return goals.map(item => {
            return {
                title: `(${item.id}) ${item.title}`,
                value: item.id
            };
        });
    }
);

export const getGoalActions = createSelector(
    goalActions,
    (goalActions = []) => {
        return goalActions.map(item => {
            return {
                ...item,
                title: `(${item.action.id}) ${item.action.title}`,
                value: item.action.id
            };
        });
    }
);
